<template>
 <div class="menu"><span></span>{{ titles }}</div>
</template>
<script>
export default {
  name: "menuTitle",
  props: {
    titles: String,
  },
  methods: {},
};
</script>

<style lang="less">
.menu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  color: #180808;
}

.menu span {
  width: 4px;
  height: 23px;
  background: linear-gradient(0deg, #0a9c1e, #79c077);
  border-radius: 2px;
  display: block;
  margin-right: 8px;
}
@media (min-width: 320px) and (max-width: 780px) {
  .menu{ margin-bottom: 10px;}

}
</style>
